<template>
  <v-card 
    height="900"
    color="#f6f7ff"
  >
    <v-card-text>
      <v-row justify="center">
        <v-col 
          cols="12" 
          sm="10" 
          lg="8"
        >
          <p class="text-subtitle-1 text-lg-h5 font-weight-bold primary--text title-login">Inicio de Sesión</p>

          <v-form 
            ref="form" 
            v-model="form"
          >
            <v-text-field
              outlined
              type="text"
              label="Correo Electrónico"
              v-model="correo"
              :rules="correoReglas"
              class="mt-10"
            >
            </v-text-field>

            <v-text-field
              outlined
              :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
              :type="showPassword ? 'text' : 'password'"
              label="Contraseña"
              v-model="contrasena"
              :rules="contrasenaReglas"
              :loading="loadingTextField"
              :error-messages="mensajeSesion"
              @click:append="showPassword = !showPassword"
              @keyup.enter="iniciarSesion"
            >
            </v-text-field>

            <v-btn
              block
              x-large
              exact
              color="primary"
              class="mt-2"
              @click="iniciarSesion"
            >
              Ingresar
            </v-btn>
          </v-form>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  data: () => ({
    form: true,
    showPassword: false,
    loadingTextField: false,
    mensajeSesion: '',

    correo: null,
    correoReglas: [
      v => !!v || 'Escriba un correo electrónico',
      v => /.+@.+\..+/.test(v) || 'Correo electrónico no válido',
    ],

    contrasena: null,
    contrasenaReglas: [
      v => !!v || 'Escriba una contraseña',
    ]
  }),

  methods: {
    async iniciarSesion () {
      try {
        const usuario = {
          correo:   this.correo,
          password: this.contrasena
        }
        if (this.$refs.form.validate()) {
          this.loadingTextField = true
          await this.$store.dispatch("iniciarSesion", usuario)
          this.loadingTextField = false
          this.$router.replace({ name: 'admin' })  
        } 
      } catch (error) {
        this.loadingTextField = false
        this.mensajeSesion = "Correo electrónico o contraseña incorrectos"
      }     
    }
  }
};
</script>

<style scoped>
.title-login {
  margin-top: 30%;
}
</style>